<fieldset class="group times" [formGroup]="group()">
    <legend>{{ "FLIGHT_LIST.groups.times" | translate }}</legend>
    <div class="zone-notice">
        <kendo-svgicon [icon]="icons.warning" size="large"></kendo-svgicon>
        <div class="zone-text">
            <span>{{ "FLIGHT_LIST.edit.zone.shown" | translate: { zone: organizationZone(), offset: organizationOffset() } }}</span>
            <strong>{{ "FLIGHT_LIST.edit.zone.warning" | translate }}</strong>
        </div>
    </div>
    <div class="fields pairs">
        @for (moment of moments; track moment.control) {
            <label class="field">
                <span class="label required">{{ moment.dateTitle | translate }}</span>
                <kendo-datepicker [formControlName]="moment.date" format="dd/MM/yyyy"></kendo-datepicker>
                @if (group().controls[moment.date].invalid) {
                    <span class="error">{{ "FLIGHT_LIST.edit.errors.required" | translate }}</span>
                }
            </label>
            <label class="field">
                <span class="label required">{{ moment.title | translate }}</span>
                <kendo-textbox [formControlName]="moment.control" placeholder="HH:MM"></kendo-textbox>
                @if (group().controls[moment.control].hasError("required")) {
                    <span class="error">{{ "FLIGHT_LIST.edit.errors.required" | translate }}</span>
                } @else if (group().controls[moment.control].invalid) {
                    <span class="error">{{ "FLIGHT_LIST.edit.errors.time" | translate }}</span>
                }
            </label>
        }
        <div class="field">
            <span class="label">{{ "FLIGHT_LIST.edit.times.flightTime" | translate }}</span>
            <span class="computed" [class.wrong]="group().hasError('flightTime')">{{ durations().flightTime ?? "—" }}</span>
            @if (group().hasError("flightTime")) {
                <span class="error">{{ "FLIGHT_LIST.edit.errors.flightTime" | translate }}</span>
            }
        </div>
        <div class="field">
            <span class="label">{{ "FLIGHT_LIST.edit.times.startStopTime" | translate }}</span>
            <span class="computed" [class.wrong]="group().hasError('startStopTime')">{{ durations().startStopTime ?? "—" }}</span>
            @if (group().hasError("startStopTime")) {
                <span class="error">{{ "FLIGHT_LIST.edit.errors.startStopTime" | translate }}</span>
            }
        </div>
    </div>
</fieldset>
